import { Instance } from 'mobx-state-tree';
import { CustomerProfilePaginatedDtoModelBase } from './CustomerProfilePaginatedDtoModel.base';

/* The TypeScript type of an instance of CustomerProfilePaginatedDtoModel */
export interface CustomerProfilePaginatedDtoModelType extends Instance<typeof CustomerProfilePaginatedDtoModel.Type> {}

/* A graphql query fragment builders for CustomerProfilePaginatedDtoModel */
export { selectFromCustomerProfilePaginatedDto, customerProfilePaginatedDtoModelPrimitives, CustomerProfilePaginatedDtoModelSelector } from './CustomerProfilePaginatedDtoModel.base';

/**
 * CustomerProfilePaginatedDtoModel
 */
export const CustomerProfilePaginatedDtoModel = CustomerProfilePaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
